import {
    Clickable,
    Divider,
    ExpandIcon,
    ExpandableBox,
    SimpleList,
    SimpleListItem,
    Stack,
    Typography,
} from '@optimus-web/core';
import { LocalizedText, useLocalizeText, useToggle } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TextMessagingLabel } from '../components/Typography';
import { useUnsupportedCountries } from './countries';

interface UnsupportedCountriesProps {
    unsupportedCountryCodes: string[];
}

export const UnsupportedCountries = ({ unsupportedCountryCodes }: UnsupportedCountriesProps) => {
    const [expanded, toggleExpanded] = useToggle();
    const unsupportedCountries = useUnsupportedCountries({ unsupportedCountryCodes });
    const localizeText = useLocalizeText();

    const labelForClickable = (() => {
        const description = expanded
            ? localizeText({ textKey: TextKey.HideList })
            : localizeText({ textKey: TextKey.ViewList });

        return `${localizeText({ textKey: TextKey.CountriesNotSupported })}, ${description}`;
    })();

    const countryList = unsupportedCountries.map((country) => (
        <SimpleListItem key={country}>
            <Typography textStyle="bodyMedium" as="span">
                {country}
            </Typography>
        </SimpleListItem>
    ));

    return (
        <Stack vertical spacing="200">
            <Clickable
                aria-label={labelForClickable}
                onClick={toggleExpanded}
                type="button"
                data-test-id="toggle-countries-not-supported"
            >
                <Stack distribution="space-between">
                    <TextMessagingLabel as="span">
                        <LocalizedText textKey={TextKey.CountriesNotSupported} />
                    </TextMessagingLabel>
                    <ExpandIcon expanded={expanded} />
                </Stack>
            </Clickable>
            <Stack spacing={expanded ? '300' : '0'} vertical>
                <ExpandableBox expanded={expanded}>
                    <SimpleList columnWidth="198px" listStyle="none" spacing="0">
                        {countryList}
                    </SimpleList>
                </ExpandableBox>
                <Divider />
            </Stack>
        </Stack>
    );
};
